module.exports = __webpack_public_path__ + "img/award-notice.0df07004.png";